module.exports = __webpack_public_path__ + "static/media/om_beard_stiletto_diamond__v_shadow.06a5d45c.png";